export const PANEL_GLOBAL_THEME_ROUTE_PREFIXES = [
  '/painel/adolescentes',
  '/painel/perfis',
  '/painel/especialistas',
  '/painel/usuarios',
  '/painel/unidades',
  '/painel/modulos',
  '/painel/manual',
  '/painel/meios-entrada',
  '/painel/meios-saida',
  '/painel/decisoes',
  '/painel/motivos-mba',
  '/painel/orgaos',
  '/painel/promotores',
];

const normalizePath = (pathname = '') => {
  const trimmed = String(pathname).trim();
  if (!trimmed) return '/';
  if (trimmed === '/') return '/';
  return trimmed.endsWith('/') ? trimmed.slice(0, -1) : trimmed;
};

const matchesPrefix = (pathname, prefix) => {
  const safePath = normalizePath(pathname);
  const safePrefix = normalizePath(prefix);
  return safePath === safePrefix || safePath.startsWith(`${safePrefix}/`);
};

export const isPanelGlobalThemePath = (pathname) => (
  PANEL_GLOBAL_THEME_ROUTE_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix))
);
